// 积分抽奖管理 API
import request from '@/utils/request'

export const adminConfigApi = (data) => {
  return request({
    url: 'Lottery/adminConfig',
    method: 'post',
    data
  })
}

export const adminConfigSaveApi = (data) => {
  return request({
    url: 'Lottery/adminConfigSave',
    method: 'post',
    data
  })
}

export const adminPrizeSaveApi = (data) => {
  return request({
    url: 'Lottery/adminPrizeSave',
    method: 'post',
    data
  })
}

export const adminPrizeDeleteApi = (data) => {
  return request({
    url: 'Lottery/adminPrizeDelete',
    method: 'post',
    data
  })
}

export const adminRecordListApi = (data) => {
  return request({
    url: 'Lottery/adminRecordList',
    method: 'post',
    data
  })
}
